import { useState } from 'react';
import { supabase } from '../lib/supabase';
import type { Supplier } from '../types/types';
import { getIsoCode } from '../util/countryUtil';
import { captureSupabaseError } from '../lib/sentry';

export const useParseSuppliers = () => {
  const [data, setData] = useState<Supplier[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const parseSuppliers = async (input: string) => {
    setLoading(true);
    setError(null);
    setData(null);
    // https://qxeanjrlvevtuyyfjebf.supabase.co/functions/v1/parse-suppliers
    try {
      // use openai powered parser (gpt-4o-mini)
      //   const { data: result, error } = await supabase.functions.invoke(
      //     'bright-processor',
      //     {
      //       body: { input },
      //     }
      //   );

      // use the regex parser
      const { data: result, error } = await supabase.functions.invoke(
        'parse-suppliers',
        {
          body: input,
        }
      );

      if (error) throw error;

      console.log('Parsed suppliers result:', result.suppliers);
      // Expect result to have { suppliers: [...] }
      setData(
        result.suppliers.map((s: Supplier) => {
          const iso = getIsoCode(s?.country ?? '');
          return {
            ...s,
            country: iso ?? s?.country, // replace with ISO if found, else keep original
          };
        }) ?? []
      );
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      captureSupabaseError(err, { op: 'suppliers.parse' });
      console.error('Failed to parse suppliers:', err);
      setError(err.message || 'Unexpected error');
      // TODO: log error to monitoring service
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, parseSuppliers };
};
